import React from 'react';
import { connect } from 'react-redux';

import { setModal } from 'ducks/modal';
import { deleteEntity } from 'ducks/details';
import { Row, Column } from 'components/UIKit/Flex';
import DangerButton from 'components/UIKit/Button/DangerButton';
import Button from 'components/UIKit/Button/Button';
import { useParams } from 'react-router';

let DeleteEntities = ({ dispatch, entities }) => {
  const params = useParams();
  return (
    <Column style={{ padding: '3rem', justifyContent: 'center' }}>
      <Row style={{ justifyContent: 'center' }}>
        {`Are you sure you want to delete ${entities.length} entities?`}
      </Row>
      <Row style={{ justifyContent: 'center', marginTop: '1rem' }}>
        <Button onClick={() => dispatch(setModal({ Component: null }))}>No, Cancel</Button>
        <DangerButton
          onClick={
            () => {
              dispatch(deleteEntity(entities.map(x => x.id), params));
              dispatch(setModal({ Component: null }));
            }
          }
        >
          Yes, Delete
        </DangerButton>
      </Row>
    </Column>
  );
};

export default connect()(DeleteEntities);
